export const animationsList = [
    /*    {
        label: "Блик",
        value: "blink"
    },*/
    {
        label: "Та-да",
        value: "tada"
    },
    {
        label: "Вибрация",
        value: "buzz"
    },
    {
        label: "Колебание",
        value: "wobble"
    },
    {
        label: "Встряхивание X",
        value: "shake-x"
    },
    {
        label: "Встряхивание Y",
        value: "shake-y"
    },
    {
        label: "Резинка",
        value: "rubber"
    },
    {
        label: "Пульсирование",
        value: "pulse"
    },
    {
        label: "Сердцебиение",
        value: "heart"
    }
];
